// src/pages/private/sinisters/Modals/ModalCancelSinister.tsx

import { Box, Button, Divider, Grid, Icon, MenuItem, Modal, Typography, useMediaQuery, useTheme } from "@mui/material";
import { FormHandles } from "@unform/core";
import { useRef } from "react";
import * as yup from "yup";
import { VForm, VTextField } from "../../../../shared/forms";
import { useCancelSinister } from "../../hooks/useCancelSinisterStatus";

interface IFormDataCancel {
	canceledReason: string;
	canceledObs?: string;
}

interface ModalCancelSinisterProps {
	open: boolean;
	id: string;
	onClose: () => void;
	refetch: () => void;
}

export default function ModalCancelSinister({ open, id, onClose, refetch }: ModalCancelSinisterProps) {
	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down("sm"));
	const formRef = useRef<FormHandles>(null);

	const schema = yup.object().shape({
		canceledReason: yup.string().required("Motivo é obrigatório"),
		canceledObs: yup.string().optional(),
	});

	const { handleCancel, isLoading, isUploading } = useCancelSinister({
		id,
		schema,
		onSuccess: () => {
			refetch();
			onClose();
		},
		setFormErrors: (errors) => {
			formRef.current?.setErrors(errors);
		},
	});

	return (
		<Modal open={open} onClose={onClose}>
			<Box
				sx={{
					width: smDown ? "90%" : "45%",
					bgcolor: "background.paper",
					p: 3,
					mx: "auto",
					mt: 10,
					borderRadius: 2,
				}}
			>
				<Typography variant="h6" mb={2}>
					Cancelar Sinistro
				</Typography>

				<VForm
					ref={formRef}
					onSubmit={handleCancel}
					initialData={{ canceledReason: "", canceledObs: "" }}
					onPointerEnterCapture={() => formRef.current?.setErrors({})}
					onPointerLeaveCapture={() => formRef.current?.setErrors({})}
					placeholder={"Digite aqui..."}
				>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<VTextField name="canceledReason" label="Motivo" select fullWidth disabled={isLoading}>
								<MenuItem value={"inadimplência"}>Inadimplência da imobiliária</MenuItem>
								<MenuItem value={"irregular"}>Contratação irregular</MenuItem>
								<MenuItem value={"inexistente"}>Garantia inexistente</MenuItem>
								<MenuItem value={"irregularidades"}>Irregularidades identificadas</MenuItem>
								<MenuItem value={"discharge_tenant"}>Quitação do locatário</MenuItem>
								<MenuItem value={"outros"}>Outros</MenuItem>
							</VTextField>
						</Grid>
						<Grid item xs={12}>
							<VTextField name="canceledObs" label="Observação" multiline maxRows={3} fullWidth disabled={isLoading} />
						</Grid>
					</Grid>

					<Divider sx={{ my: 2 }} />

					<Grid container justifyContent="center" spacing={2}>
						<Grid item xs={12} sm="auto">
							<Button variant="contained" color="primary" fullWidth disabled={isUploading} onClick={() => formRef.current?.submitForm()}>
								Confirmar
							</Button>
						</Grid>
						<Grid item xs={12} sm="auto">
							<Button variant="outlined" fullWidth onClick={onClose} startIcon={<Icon>arrow_back</Icon>}>
								Voltar
							</Button>
						</Grid>
					</Grid>
				</VForm>
			</Box>
		</Modal>
	);
}
